const GH_MENTION_BLOT_ATTRIBUTES = ["data-test-id", "data-id", "data-name", "data-email", "contenteditable"];
const OKR_LINK_SELECTOR_BLOT_ATTRIBUTES = ["data-url", "data-title", "data-type", "aria-label", "tabindex"];

export const GH_BLOT_ATTRIBUTES = [...GH_MENTION_BLOT_ATTRIBUTES, ...OKR_LINK_SELECTOR_BLOT_ATTRIBUTES];
